<script lang="ts">
  import {
    Video,
    SquarePen,
    Gift,
    Image,
    ClipboardCheck,
    Users,
    GraduationCap,
    TrendingUp,
    BadgeCheck,
    FileDown
  } from "lucide-svelte"

  const h = {
    video: Video,
    edit: SquarePen,
    gift: Gift,
    photograph: Image,
    tasks: ClipboardCheck,
    team: Users,
    certificate: GraduationCap,
    progress: TrendingUp,
    badge: BadgeCheck,
    download: FileDown
  }

  export let icon:
    | "video"
    | "edit"
    | "gift"
    | "photograph"
    | "tasks"
    | "users"
    | "academic"
    | "launch"
    | "badge"
    | "download"
</script>

<svelte:component this={h[icon]} class="text-gray-400 w-4 h-4" />
